import { useNavigate } from "react-router-dom";
import { Select } from "antd";
import { useContext } from 'react';
import { LangContext } from "../utils/LanguageProvider";
import { getFromLocalStorage } from "../utils/localStorage";
import findTranslatedUrl from "../utils/findTranslatedUrl";

const LanguageBtn = () => {
  const navigate = useNavigate();
  const { lang, changeLang } = useContext(LangContext);
  const handleLangChange = (newLang) => {
    const currentPath = window.location.pathname;
    const menuData = getFromLocalStorage("menuData");

    const translated = findTranslatedUrl(currentPath, newLang, menuData);
    const targetPath = translated || `/${newLang}`;

    changeLang(newLang);
    navigate(targetPath, { replace: true });
  };

  return (
    <Select
      defaultValue="es"
      value={lang}
      onChange={handleLangChange}
      className="language-btn"
      suffixIcon={null}
    >
      <Select.Option value="es">Español</Select.Option>
      <Select.Option value="pt">Portugués (BR)</Select.Option>
      <Select.Option value="en">English</Select.Option>
    </Select>
  );
};

export default LanguageBtn;